<template>
  <pt-lab-product class="pt-lab-product__page"></pt-lab-product>
</template>

<script>
import PtLabProduct from 'cps/lab-product/pt-lab-product/withData'
export default {
  name: 'pt-lab-product__view',
  components: {
    'pt-lab-product': PtLabProduct
  }
}
</script>
